import { useEffect, useRef, useState } from "react";
import styles from "./MessageBubble.module.scss";

const TypingDots = () => (
  <div className={styles.typingDots}>
    <span></span>
    <span></span>
    <span></span>
  </div>
);

const MessageBubble = ({
  userName,
  message,
  delay = 0,
  previousMessageDelay = 0,
  initialDelay = 0,
}) => {
  const isLexi = userName === "Lexi";
  const [isVisible, setIsVisible] = useState(false);
  const [isTyping, setIsTyping] = useState(true);
  const contentRef = useRef(null);

  useEffect(() => {
    const visibilityTimer = setTimeout(() => {
      setIsVisible(true);
    }, initialDelay + previousMessageDelay);

    const typingTimer = setTimeout(() => {
      setIsTyping(false);
    }, initialDelay + delay);

    return () => {
      clearTimeout(visibilityTimer);
      clearTimeout(typingTimer);
    };
  }, [delay, previousMessageDelay, initialDelay]);

  if (!isVisible) return null;

  return (
    <div
      className={`${styles.container} ${isLexi ? styles.containerLexi : styles.containerGuest}`}
      style={{ animationDelay: "0ms" }}
    >
      <div
        className={`${styles.bubble} ${isLexi ? styles.bubbleLexi : styles.bubbleGuest}`}
      >
        <span
          className={`${styles.userName} ${isLexi ? styles.userNameLexi : styles.userNameGuest}`}
        >
          {userName}
        </span>
        <div className={styles.messageContent} ref={contentRef}>
          <div className={isTyping ? styles.typing : styles.message}>
            {isTyping ? (
              <TypingDots />
            ) : (
              <div dangerouslySetInnerHTML={{ __html: message }} />
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default MessageBubble;
